import PropTypes from 'prop-types'
import React from 'react'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

export const ItemImage = ({ img, className, title, as, href, isLoading }) => {
  const { t } = useTranslation('common')

  return (
    <div className={className}>
      {!isLoading ? (
        <Link href={href} as={as}>
          <a>{'\n'}
            <div
              className={'oglas-item-slika'}
              style={{
                position: 'relative',
                'min-height': '126px'
              }}
              data-tip={title}
            >
              <img
                src={img}
                alt={title}
                // style={{ objectFit: 'contain' }}
                style={{ objectFit: 'cover' }}
              />
            </div>
          </a>
        </Link>
      ) : (
        <div>
          <a style={{ cursor: 'not-allowed' }}>{'\n'}
            <div
              className={'oglas-item-slika'}
              style={{
                position: 'relative',
                'min-height': '126px'
              }}
              data-tip={title}
            >
              <img
                src={img}
                alt={title}
                // style={{ objectFit: 'contain' }}
                style={{ objectFit: 'cover' }}
              />
            </div>
          </a>
        </div>
      )}
    </div>
  )
}

ItemImage.propTypes = {
  img: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  as: PropTypes.string,
  href: PropTypes.string
}
